import { render } from "./ui-month-selector.vue?vue&type=template&id=8a8b258e&ts=true"
import script from "./ui-month-selector.vue?vue&type=script&lang=ts"
export * from "./ui-month-selector.vue?vue&type=script&lang=ts"

import "./ui-month-selector.vue?vue&type=style&index=0&id=8a8b258e&lang=less"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__